import { GovernedIntelligenceDashboard } from "@/components/GovernedIntelligenceDashboard";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/effectiveness-prevention")({
  head: () => ({
    meta: [
      { title: "Prevention Intelligence — Broadview Warranty Intelligence" },
      {
        name: "description",
        content:
          "Governed effectiveness, read-across, and prevention evidence with explicit demonstration authority.",
      },
    ],
  }),
  component: EffectivenessPreventionPage,
});

function EffectivenessPreventionPage() {
  return <GovernedIntelligenceDashboard view="effectiveness-prevention" />;
}
